import React, { useEffect, useState } from 'react';
import { Checkbox, Groupper, Button, Message } from 'react-frontier';
import UserAccess from '../UserAccess';
import { partition } from '../SiteUtil';

interface UserAccessConfigProps{
	accesss: number[],
	onAccessChange: (acc: number[])=>void,
	style?: React.CSSProperties
	width?: number,
	onClick?: (setLoading: (l: boolean) => void) => void;
	errorPrompts?: string[]
}

var UserAccessConfig = (props: UserAccessConfigProps)=>{
	var isCategoryChecked = (category_id: number)=>{
		var cat = UserAccess.ACCESS_ARRAY.find(a=>a.id==category_id);
		if(!cat || cat.access.length==0) return false;
		var cat_acc = cat.access.map(a=>a.id);
		for(var i of cat_acc){
			if(props.accesss.indexOf(i)==-1) return false;
		}
		return true;
	}

	var onCategoryChecked = (category_id: number)=>{
		return (checked: boolean)=>{
			var cat = UserAccess.ACCESS_ARRAY.find(a=>a.id==category_id);
			if(!cat || cat.access.length==0) return;
			var cat_acc = cat.access.map(a=>a.id);
			var new_acc = [...props.accesss];
			if(checked){
				for(var i of cat_acc){
					if(new_acc.indexOf(i)==-1){
						new_acc.push(i);
					}
				}
			}else{
				new_acc = new_acc.filter(a=>cat_acc.indexOf(a)==-1);
			}
			props.onAccessChange(new_acc);
		}
	}

	var onAccessChange = (access: number)=>{
		return (checked: boolean)=>{
			if(props.accesss.indexOf(access)==-1){
				if(!checked) return;
				props.onAccessChange([...props.accesss, access]);
			}else{
				if(checked) return;
				props.onAccessChange(props.accesss.filter(a=>a!==access));
			}
		}
	}

	return <Groupper className="ar user-access-config" style={props.style} title={'Permisos'} width={props.width} actions={<Button text='Guardar' color='black' onClick={props.onClick}/>}>
		{UserAccess.ACCESS_ARRAY.map(((a, index) =>(
			<React.Fragment key={`USR-ACC-CFG-${a.id}`}>
				<Groupper.Divider style={{ paddingLeft: 10, paddingRight: 10, marginTop: index === 0 ? -20 : undefined, }}>
					<Checkbox 
						checked={isCategoryChecked(a.id)} 
						onChange={onCategoryChecked(a.id)} 
						style={{ marginBottom: 20 }}
					/>
					<div className="name" style={{ marginLeft: 10 }}>{a.name}</div>
				</Groupper.Divider>		
				<table className="access" style={{ width: '100%', paddingBottom: 0 }}>
					<tbody>
						{partition(a.access, 2).map((b, i) => (
								<tr key={`USR-ACC-TR-${a.id}-${i}`}>
									{b.map(acc => (
										<td style={{ width: '50%' }} key={`USR-ACC-TD-${acc.id}`}>
												<div style={{ marginTop: 5 }}>
													<Checkbox 
														checked={props.accesss.indexOf(acc.id) !== -1} 
														color='blue' 
														label={<span><span style={{ color: 'gray', fontSize: 11 }}>[{acc.id}] </span>{acc.name}</span>} 
														onChange={onAccessChange(acc.id)}
														style={{ marginLeft: -10}}
													/>
												</div>
										</td>
									))}
								</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		)))}
		<Message type="error" list={props.errorPrompts} size='small'/>
	</Groupper>
}

export default UserAccessConfig;